import { Button, Col, Icon, Modal, Radio, Row, Spin } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { onChange, onLoadPrinter, onOk, onSavePrinter } from './../../../actions/settingPrinterAction';
import Header from './../../../components/header';
import SideBar from './../../../components/sidebar-setting';
import TestPrinter from './../../../components/test-printer';
import lang from './../../../languages/en';
import printerImg  from './../../../resources/assets/images/printDisable.png';
import { alertError } from './../../../services/dialog';
import { setHeight, titleHead } from './../../../services/helper';
import { getPrinter } from './../../../utils/settingPrinter';
import handlePermission from './../../app/handlePermission';
import { settingPrintOptions, permissions } from './../../../constants';
import './styles.css';

const RadioGroup = Radio.Group

class SettingPrinter extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isLoading: false,
            disabled: !handlePermission(permissions.PrinterSavePrinterSetting)
        }

    }

    componentDidMount() {
        titleHead('Setting Printer')

        // Set the same height for three column when resize window
        setHeight()
        window.addEventListener('resize', this.updateDimensions)

        let _this = this
        getPrinter().then(printer => {
            let payload = {
                PaperSize: printer.data.data.PaperSize,
                PrintingOptionIN: printer.data.data.PrintingOptionIN,
                ID: printer.data.data.ID,
            }
            _this.props.onLoadPrinter(payload)
        })
    }

    updateDimensions() {
        setHeight()
    }

    cancel = () => {
        getPrinter().then(printer => {
            let payload = {
                PaperSize: printer.data.data.PaperSize,
                PrintingOptionIN: printer.data.data.PrintingOptionIN,
                ID: printer.data.data.ID,
            }
            this.props.onLoadPrinter(payload)
        })
    }

    handleLoading = (value) => {
        this.setState({
            isLoading: value
        })
    }

    onClick = () => {
        this.props.printer.PaperSize ? this.props.onSavePrinter(this.props.printer) : alertError(lang.setting_print)
    }

    onChangePaperSize = e => {
        this.props.onChange({ PaperSize: e.target.value })
    }

    onChangePrintOption = e => {
        this.props.onChange({ PrintingOptionIN: e.target.value })
    }

    render() {
        const { disabled } = this.state
        const { printer } = this.props

        return (
            <div id="setting-printer">
                <Modal
                    visible={this.props.save_success_visible}
                    closable={false}
                    footer={[
                        <Button key="ok_modal_save_success" type="primary" onClick={this.props.onOk}>
                            OK
                        </Button>,
                    ]}
                >
                    <p> Save Success!</p>
                </Modal>
                <Modal
                    visible={this.props.save_failure_visible}
                    closable={false}
                    footer={[
                        <Button key="ok_modal_save_failure" type="primary" onClick={this.props.onOk}>
                            OK
                        </Button>,
                    ]}
                >
                    <p>Save Failure!</p>
                </Modal>
                <Header />
                <Spin spinning={this.state.isLoading} tip="Loading...">
                    <div className="content">
                        <Row style={{ height: '100%' }}>
                            <Col id="setting-left" className="left-col" span={3}>
                                <SideBar />
                            </Col>
                            <Col id="setting-right" className="right-col" span={21}>
                                <div className="title">
                                    <img className="printer" src={printerImg} />
                                    <span className="text-title">Printers</span>
                                </div>
                                <Row className="verify">
                                    <Row>
                                        <Col span={5} />
                                        <Col span={10}>
                                            <div className='wrap-select-print'>
                                                <div className="select_printer">
                                                    <span>Select Printer</span>
                                                </div>
                                                <RadioGroup
                                                    name="PagerSize"
                                                    onChange={e => this.onChangePaperSize(e)}
                                                    value={printer ? printer.PaperSize : null}
                                                    disabled={disabled}
                                                >
                                                    <Radio className="radioStyle" value={1}>Label Printer</Radio>
                                                    <Radio className="radioStyleMiddle" value={2}>Standard Printer (Letter)</Radio>
                                                    <Radio className="radioStyle" value={3}>Standard Printer (A4)</Radio>
                                                </RadioGroup>
                                            </div>
                                        </Col>
                                        <Col span={4} className="radio">
                                            <div className="test-printer">
                                                <TestPrinter
                                                    handleLoading={this.handleLoading}
                                                />
                                            </div>
                                        </Col>
                                        <Col span={5} />
                                    </Row>
                                    <Row>
                                        <Col span={5} />
                                        <Col span={14}>
                                            <div className='warning-print-popup'>
                                                <Icon className='icon-warning-loading' type="warning" />
                                                <div className='icon-warning-loading-message'>
                                                    <p> {lang.warning_print_popup}</p>
                                                    <p>{lang.warning_print_popup_line2}</p>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col span={5} />
                                    </Row>
                                    <Row>
                                        <Col span={5} />
                                        <Col span={10}>
                                            <div className='wrap-select-print'>
                                                <div className="select_printer">
                                                    <span>{lang.printers_print_option}</span>
                                                </div>
                                                <RadioGroup
                                                    name="PrintOption"
                                                    onChange={e => this.onChangePrintOption(e)}
                                                    value={printer && printer.PrintingOptionIN}
                                                    disabled={disabled}
                                                >
                                                    <Radio
                                                        className="radioStyle"
                                                        value={settingPrintOptions.ShippingLabelOnly}
                                                    >
                                                        {lang.printers_print_shipping_label}
                                                    </Radio>
                                                    <Radio
                                                        className="radioStyleMiddle"
                                                        value={settingPrintOptions.ShippingLabelAndPacking}
                                                    >
                                                        {lang.printers_print_both}
                                                    </Radio>
                                                </RadioGroup>
                                            </div>
                                        </Col>
                                    </Row>
                                </Row>
                                <Row className="footer-component">
                                    <div className="fix-footer">
                                        <Button className="cancel" onClick={this.cancel}
                                            disabled={disabled || !handlePermission(permissions.PrinterSavePrinterSetting)}>Cancel</Button>
                                        <Button
                                            className="save ant-btn-primary"
                                            loading={this.props.loading_save}
                                            onClick={this.onClick}
                                            disabled={disabled
                                                || !handlePermission(permissions.PrinterSavePrinterSetting)
                                                || !(printer && printer.PrintingOptionIN)
                                                || !(printer && printer.PaperSize)
                                            }
                                        >Save</Button>
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </Spin>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        printer: state.settingPrinterReducer.printer,
        save_success_visible: state.settingPrinterReducer.save_success_visible,
        save_failure_visible: state.settingPrinterReducer.save_failure_visible,
        loading_save: state.settingPrinterReducer.loading_save,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onOk: () => {
            dispatch(onOk())
        },
        onChange: payload => {
            dispatch(onChange(payload))
        },
        onSavePrinter: payload => {
            dispatch(onSavePrinter(payload))
        },
        onLoadPrinter: payload => {
            dispatch(onLoadPrinter(payload))
        },
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SettingPrinter)



// WEBPACK FOOTER //
// ./src/containers/setting/setting-printer/index.js